// extracted by mini-css-extract-plugin
export default {"container":"G","header":"H","logodesktop":"I","logomobile":"J","imgcontainer":"K","slidercontainer":"L","slick-slider":"M","slick-initialized":"N","sliderbox":"O","headline":"P","mainheadline":"Q","capitalize":"R","desc":"S","descitalic":"T","desccenter":"U","descborder":"V","subdesc":"W","welcomeslide":"X","desccard":"Y","img":"Z","button":"aa","buttonskip":"ba","customPosition":"ca"};
    if(module.hot) {
      // 1714422955174
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  